import { render, staticRenderFns } from "./DadosNascimento.vue?vue&type=template&id=8bdcb5a2&scoped=true&"
import script from "./DadosNascimento.vue?vue&type=script&lang=js&"
export * from "./DadosNascimento.vue?vue&type=script&lang=js&"
import style0 from "./DadosNascimento.vue?vue&type=style&index=0&id=8bdcb5a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdcb5a2",
  null
  
)

export default component.exports